module.exports = __webpack_public_path__ + "static/media/github.ba00f667.svg";